import { Container } from "reactstrap";
import { ToastContainer, BackLink } from "../../components/Common";
import UserDetailsPage from "./page";

const UserDetailsPageWrapper = () => {
    return (
        <div className="page-content">
            <Container fluid>
                <BackLink />
                <UserDetailsPage />
            </Container>
            <ToastContainer />
        </div>
    );
};

export default UserDetailsPageWrapper;
